import lodash from "lodash";
import {
    createFieldInput, createFieldRadioGroup,
    createFieldSelect, createFieldTemplateBuilder, createFieldTextArea
} from "../../../../../components/input/template-builder/template-builder.logic";
import i18n from "../../../../../i18n";
import store from "../../../../../store";
import { conditionFormChecker, putField } from "../../../../../utils/form";
import { createLoading } from "../../../../../utils/loading";
import { createOnUpdateRefSubStance, filterSubStance } from "../haz-discuss-product/haz-discuss-main-sub-stance.logic";

export const { isLoading, setIsLoading } = createLoading();

const yesNo = [
    { id: "false", value: false, name: i18n.global.t("views.request.hazDiscuss.isOtherResult.no") },
    { id: "true",  value: true, name: i18n.global.t("views.request.hazDiscuss.isOtherResult.yes") }
];

export const callCountry = ({ searchQuery }) =>
    store.dispatch("resource/v1/master/country/cacheFindAll", {
        where: [
            { name: "nameEnS", type: "String", operator: "like", value: searchQuery },
            { logic: "OR", name: "nameTh", operator: "like", value: searchQuery }
        ],
        sort: [{ name: "seq", type: "ASC" }]
    });
export const callHazSubStanceTypeMain = ({ searchQuery }) =>
    store.dispatch("resource/v1/master/lookup/cacheFindAllByGroup", { group: "HAZ_SUB_STANCE_TYPE_MAIN", value: searchQuery });
export const callToUse = ({ searchQuery }) =>
    store.dispatch("resource/v1/master/lookup/cacheFindAllByGroup", { group: "HAZ_PRODUCT_USE_DISCUSS", value: searchQuery });
export const callMainOperation = ({ searchQuery }) =>
    store
        .dispatch("resource/v1/master/lookup/cacheFindAllByGroup", { group: "USER_OBJECTIVE", value: searchQuery })
        .then(items => items.filter(item => ["1", "2", "4", "5"].includes(item.key)));
export const callSubOperation = ({ searchQuery }) =>
    store.dispatch("resource/v1/master/lookup/cacheFindAllByGroup", { group: "SUB_ACTION", value: searchQuery });
export const callMainObjective = ({ searchQuery }) =>
    store.dispatch("resource/v1/master/lookup/cacheFindAllByGroup", { group: "PURPOSE", value: searchQuery });
export const callSubObjective = ({ searchQuery }) =>
    store.dispatch("resource/v1/master/lookup/cacheFindAllByGroup", { group: "SUB_PURPOSE", value: searchQuery });
export const callDiscussTopic = ({ searchQuery }) =>
    store.dispatch("resource/v1/master/lookup/cacheFindAllByGroup", { group: "DISCUSS_TOPIC", value: searchQuery });

export const createField = ({ props, data, key /*isLoading*/ }) => {
    const { viewOnly /*menuContext*/ } = props;
    const { useForm } = data;
    const { modelRef } = useForm;
    const model = key ? lodash.get(modelRef, key) : modelRef;
    const prefix = key ? `${key}.` : "";
    return putField({
        data,
        fields: [
            createFieldTemplateBuilder({
                colProp: () => ({ xs: 24, md: 12 }),
                inputProp: () => ({
                    useForm: useForm,
                    fields: [
                        createFieldSelect({
                            visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                            key: `${prefix}refMainOperation`,
                            colProp: () => ({ xs: 24 }),
                            formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                            label: () => i18n.global.t("model.hazDiscuss.refMainOperation"),
                            inputProp: ({ field }) =>
                                lodash.merge(
                                    {
                                        value: model.refMainOperation,
                                        "onUpdate:value": value => {
                                            model.refMainOperation = value;
                                            clearMainSubStanceRefSubStance({ data, key });
                                        },
                                        disabled: viewOnly,
                                        list: callMainOperation,
                                        optLabel: "value"
                                    },
                                    conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                                ),
                            changeLog: { getValue: ({ record, field }) => lodash.get(record, `${field.key}.value`) }
                        }),
                        createFieldSelect({
                            visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                            key: `${prefix}refMainObjective`,
                            colProp: () => ({ xs: 24 }),
                            formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                            label: () => i18n.global.t("model.hazDiscuss.refMainObjective"),
                            inputProp: ({ field }) =>
                                lodash.merge(
                                    {
                                        value: model.refMainObjective,
                                        "onUpdate:value": value => {
                                            model.refMainObjective = value;
                                            model.refSubObjective = null;
                                            clearMainSubStanceRefSubStance({ data, key });
                                        },
                                        disabled: viewOnly,
                                        list: callMainObjective,
                                        optLabel: "value"
                                    },
                                    conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                                ),
                            changeLog: { getValue: ({ record, field }) => lodash.get(record, `${field.key}.value`) }
                        }),
                        createFieldSelect({
                            visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                            key: `${prefix}refManufactureCountry`,
                            colProp: () => ({ xs: 24 }),
                            formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                            label: () => i18n.global.t("model.hazDiscuss.refManufactureCountry"),
                            inputProp: ({ field }) =>
                                lodash.merge(
                                    {
                                        value: model.refManufactureCountry,
                                        "onUpdate:value": value => (model.refManufactureCountry = value),
                                        disabled: viewOnly,
                                        list: callCountry,
                                        renderLabel: ({ item }) => (
                                            <span>
                                                {item.nameEnS} : {item.nameTh}
                                            </span>
                                        ),
                                        optKey: "id"
                                    },
                                    conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                                ),
                            changeLog: { getValue: ({ record, field }) => lodash.get(record, `${field.key}.nameTh`) }
                        })
                    ],
                    skeleton: isLoading.value
                })
            }),
            createFieldTemplateBuilder({
                colProp: () => ({ xs: 24, md: 12 }),
                inputProp: () => ({
                    useForm: useForm,
                    fields: [
                        createFieldSelect({
                            visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                            key: `${prefix}refSubOperation`,
                            colProp: () => ({ xs: 24 }),
                            formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                            label: () => i18n.global.t("model.hazDiscuss.refSubOperation"),
                            inputProp: ({ field }) =>
                                lodash.merge(
                                    {
                                        value: model.refSubOperation,
                                        "onUpdate:value": value => {
                                            model.refSubOperation = value;
                                            clearMainSubStanceRefSubStance({ data, key });
                                        },
                                        disabled: viewOnly,
                                        list: callSubOperation,
                                        optLabel: "value"
                                    },
                                    conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                                ),
                            changeLog: { getValue: ({ record, field }) => lodash.get(record, `${field.key}.value`) }
                        }),
                        createFieldSelect({
                            visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                            key: `${prefix}refSubObjective`,
                            colProp: () => ({ xs: 24 }),
                            formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                            label: () => i18n.global.t("model.hazDiscuss.refSubObjective"),
                            inputProp: ({ field }) =>
                                lodash.merge(
                                    {
                                        value: model.refSubObjective,
                                        "onUpdate:value": value => {
                                            const oldValue = model.refSubObjective;
                                            model.refSubObjective = value;
                                            if (oldValue != value && oldValue?.key == "3") {
                                                model.otherSubObjective = null;
                                            }
                                            clearMainSubStanceRefSubStance({ data, key });
                                        },
                                        disabled: viewOnly,
                                        list: ({ searchQuery }) => callSubObjective({ searchQuery }).then(items => items.filter(item => item.key !== "3")),
                                        optLabel: "value"
                                    },
                                    conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                                ),
                            changeLog: { getValue: ({ record, field }) => lodash.get(record, `${field.key}.value`) }
                        }),
                        createFieldInput({
                            visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }), //&& model.refSubObjective,
                            key: `${prefix}otherSubObjective`,
                            colProp: () => ({ xs: 24 }),
                            formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                            label: () => i18n.global.t("model.hazDiscuss.otherSubObjective"),
                            inputProp: ({ field }) =>
                                lodash.merge(
                                    {
                                        value: model.otherSubObjective,
                                        "onUpdate:value": value => (model.otherSubObjective = value),
                                        disabled: viewOnly
                                    },
                                    conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                                )
                        })
                    ],
                    skeleton: isLoading.value
                })
            }),
            createFieldSelect({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                key: `${prefix}refDiscussTopic`,
                colProp: () => ({ xs: 24 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () => i18n.global.t("model.hazDiscuss.refDiscussTopic"),
                inputProp: ({ field }) =>
                    lodash.merge(
                        {
                            value: model.refDiscussTopic,
                            "onUpdate:value": value => {
                                const oldValue = model.refDiscussTopic;
                                model.refDiscussTopic = value;
                                if (oldValue != value && oldValue?.key == "2") {
                                    model.otherDiscussTopic = null;
                                }
                            },
                            disabled: viewOnly,
                            list: callDiscussTopic,
                            optLabel: "value"
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    ),
                changeLog: { getValue: ({ record, field }) => lodash.get(record, `${field.key}.value`) }
            }),
            createFieldTextArea({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                key: `${prefix}otherDiscussTopic`,
                colProp: () => ({ xs: 24 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () => i18n.global.t("model.hazDiscuss.otherDiscussTopic"),
                inputProp: ({ field }) =>
                    lodash.merge(
                        {
                            value: model.otherDiscussTopic,
                            "onUpdate:value": value => (model.otherDiscussTopic = value),
                            disabled: viewOnly
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    )
            }),
            createFieldRadioGroup({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field, model } }),
                key: `${prefix}isOtherResult`,
                colProp: () => ({ xs: 24 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () => i18n.global.t("model.hazDiscuss.isOtherResult"),
                inputProp: ({ field }) =>
                    lodash.merge(
                        {
                            value: model.isOtherResult === true ? yesNo.find(d => d.id === "true")
                                : model.isOtherResult === false ? yesNo.find(d => d.id === "false") : undefined,
                            "onUpdate:value": value => {
                                model.isOtherResult = value?.value === true;
                                model.otherResult = null;
                            },
                            disabled: viewOnly,
                            list: () => yesNo,
                            optLabel: "name"
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    ),
                changeLog: { getValue: ({ record, field }) => lodash.get(record, `${field.key}`) }
            }),
            createFieldTextArea({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                key: `${prefix}otherResult`,
                colProp: () => ({ xs: 24 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () => i18n.global.t("model.hazDiscuss.otherResult"),
                inputProp: ({ field }) =>
                    lodash.merge(
                        {
                            value: model.otherResult,
                            "onUpdate:value": value => (model.otherResult = value),
                            disabled: viewOnly
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    )
            })
        ]
    });
};

export const clearMainSubStanceRefSubStance = ({ data, key }) => {
    const { useForm } = data;
    const { modelRef } = useForm;
    const model = key ? lodash.get(modelRef, key) : modelRef;
    const prefix = key ? `${key}.` : "";
    model.mainSubStances.forEach((mainSubStance, index) => {
        filterSubStance({
            subStances: mainSubStance.refSubStance ? [mainSubStance.refSubStance] : [],
            hazDiscuss: model
        }).then(subStances => {
            if (subStances.length === 0) {
                createOnUpdateRefSubStance({ data, key: `${prefix}mainSubStances.${index}` })(null);
            }
        });
    });
};
